const l={default:"!w-[180px]",extraSmall:"!w-[150px]",fit:"!w-fit",full:"!w-[100%]",small:"!w-[160px] md:!w-[180px]"},t="div";export{l as CardSizes,t as ProductCardDefaultAsType};
